/**
 * Migration V4 → V5
 * - Adds legendMode to each chart config with default 'overlay'
 */
export function migrateV4ToV5(template: any): any {
  const t = { ...(template || {}) }
  const charts = Array.isArray(t.chartConfigs) ? t.chartConfigs : []
  t.chartConfigs = charts.map((cfg: any) => {
    const c = { ...(cfg || {}) }
    // Map legacy 'legendCorner: none' to legendMode: 'none' and set a safe corner
    if (c.legendCorner === 'none') {
      c.legendMode = 'none'
      c.legendCorner = 'tr'
    } else {
      c.legendMode = c.legendMode ? c.legendMode : 'overlay'
    }
    return c
  })
  t.version = 5
  return t
}

export default migrateV4ToV5
